var body = $('body');

$(function () {
    'use strict';
    sidebarNav();
    featured();
    toc();
    video();
    table();
    mobileMenu();
    mainSectionMenu();
    gridProductCardLinks();
});

function gridProductCardLinks() {
    $('.tag-hash-product-card-grid .kg-product-card').each(function (i, value){
        // console.log($(this).length);
        let linkNode = $(this).find('.kg-product-card-button');
        // console.log(linkNode.attr('href'));
        if (linkNode.length) {
            $(this).click(function(){
                window.location.href = linkNode.attr('href');
            });
        }
    });
}

function mainSectionMenu() {
    $('.main-section-mobile-menubutton .menubutton').click(function() {
        $('.main-section-mobile-menu').toggle();
    });
}

function sidebarNav() {
    'use strict';
    
    // Prepare currently active menu and set "next up" link
    let currentURL = window.location.href;
    let nextUp = false;
    let nextDone = false;
    $('.post-sidebar h3 + ul a').each(function (i, value){
        if (nextUp && !nextDone) {
            $('a.next-post').attr('href', $(this).attr('href'));
            $('.next-post-title span').text($(this).text());
            $('.post-container .next-post').css('display', 'block');
            nextDone = true;
            return false;
        }

        if ($(this).attr('href') === currentURL || $(this).attr('href') + `/` === currentURL) {
            $(this).addClass('current-page');
            nextUp = true;
        }
    });

    let bodyClassList = $("body").attr("class");
    let bodyClassArr = bodyClassList.split(/\s+/);
    $(bodyClassArr).each(function(index, value){
        let menuOpen = $('#' + value.substring(4) + ' + ul');
        menuOpen.css('max-height', menuOpen.prop('scrollHeight') + 'px');
        menuOpen.addClass('open');
    });
    
    setTimeout(function(){
        $('.post-sidebar h3 + ul').addClass('transition-on');
    }, 300);

    // Handle clicking on categories
    $('.post-sidebar h3').click(function() {
        $('.post-sidebar h3').each(function(i, obj) {
            let m = $('#' + obj.id + ' + ul');
            if (m.hasClass('open') && obj.id === this.id) {
                m.removeClass('open');
                m.css('max-height', '0px');
            }
        });

        let submenu = $('#' + this.id + ' + ul');
        if (submenu.hasClass('open')) {
            submenu.removeClass('open');
            submenu.css('max-height', '0px');
        } else {
            submenu.addClass('open');
            submenu.css('max-height', submenu.prop('scrollHeight') + 'px');
        }
    });
}

function featured() {
    'use strict';
    $('.featured-posts').owlCarousel({
        dots: false,
        margin: 30,
        nav: true,
        navText: [
            '<i class="icon icon-chevron-left"></i>',
            '<i class="icon icon-chevron-right"></i>',
        ],
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
        },
    });
}

function toc() {
    'use strict';
    if (!body.hasClass('post-template')) return;

    var output = '';
    var sections = 0;

    $('.post-content')
        .find('> h2, > h3')
        .each(function (_index, value) {
            var linkClass =
                $(this).prop('tagName') == 'H3'
                    ? 'widget-list-item indented'
                    : 'widget-list-item';
            output +=
                '<li class="' +
                linkClass +
                '"><a href="#' +
                $(value).attr('id') +
                '">' +
                $(value).text() +
                '</a></li>';

            sections += 1;
        });

    if (sections > 2) {
        $('.widget-toc .widget-list').html(output);
        new Gumshoe('.widget-toc .widget-list-item a', {offset: 40});
    } else {
        $('.widget-toc').remove();
    }
}

function video() {
    'use strict';
    $('.post-content').fitVids();
}

function table() {
    'use strict';
    if (body.hasClass('post-template') || body.hasClass('page-template')) {
        var tables = $('.post-content').find('.table');
        tables.each(function (_, table) {
            var labels = [];

            $(table)
                .find('thead th')
                .each(function (_, label) {
                    labels.push($(label).text());
                });

            $(table)
                .find('tr')
                .each(function (_, row) {
                    $(row)
                        .find('td')
                        .each(function (index, column) {
                            $(column).attr('data-label', labels[index]);
                        });
                });
        });
    }
}

function mobileMenu() {
    'use strict';
    $('.gh-burger').on('click', function () {
        $('body').toggleClass('gh-head-open');
    });
}
